import React from 'react';
import { Row } from 'react-bootstrap';
export default function DataNotFound() {
  return (
    <Row className="g-0 align-items-center justify-content-center my-2">
      Data Not Found
    </Row>
  );
}
